import { tivio } from '@tivio/core-js'
import { PaginationInterface, SubscribeToSeriesEpisodesOptions, Video } from '@tivio/types'
import { useEffect, useState } from 'react'

import { useError } from './useError'


/**
 * Returns videos with given tag ids
 * @param tagIds - tag ids
 * @param options - subscription options
 */
export const useSubscribeToSeriesEpisodes = (
    seriesRef: any,
    options: SubscribeToSeriesEpisodesOptions = {},
) => {
    const [pagination, setPagination] = useState<PaginationInterface<Video> | null>(null)
    const { error, raiseError } = useError()

    useEffect(() => {
        if (!seriesRef) {
            return
        }
        const disposer = tivio.subscribeToSeriesEpisodes(
            // TODO - resolve tags count another way
            seriesRef,
            (error, data) => {
                if (error) {
                    raiseError(error)
                }

                if (data) {
                    setPagination({
                        items: data.items,
                        fetchMore: data.fetchMore,
                        hasNextPage: data.hasNextPage,
                        loading: data.loading,
                    })
                }
            },
            options,
        )

        return () => {
            disposer?.()
        }
    }, [options, raiseError, seriesRef])


    return {
        pagination,
        error,
    }
}